export function allNonEmpty(...strings) {
    strings.forEach(s => {
        if (s === "" & s === null) {
            return false;
        }
    });
    return true;
}

export const verifyNonNull = (obj, type) => {
    if (obj === null || obj === undefined) {
        throw new Error(type + " must not be null.")
    }
}

export const verifyNonEmpty = (obj, type) => {
    if (!obj.length)
        throw new Error(type + " must not be empty.")
}

export const getData = async (path) => {
    return fetch(path, {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        }
    }).then((response) => response.json())
}

export const getOrDefault = (obj, def, source = undefined) => {
    if (obj === null || obj === undefined) {
        return def
    }
    if (typeof obj !== 'boolean' && typeof obj !== 'number' && obj.length === 0) {
        return def
    }
    if (typeof obj === 'boolean') {
        if (source) {
            console.info(`Boolean value found in getOrDefault from source ${source}. This might be unintended.`)
        }
        return !!obj
    }
    return obj;
}

export const format = (str, ...args) => {
    for (let i = 0; i < args.length; i++) {
        if (args[i] === null || args[i] === undefined) {
            args[i] = '';
        }
        str = str.replace(`{${i}}`, args[i]);
    }
    return str;
}

export const getDirectionByLanguage = (language) => {
    return ['ar-SA', 'he-IL'].includes(language) ? 'rtl' : 'ltr'
}

export const getLtrOrRtlByAlignment = (alignment) => {
    return alignment === 'right' ? 'rtl' : 'ltr'
}

export const isRTL = () => {
    return document.dir === 'rtl'
}

export const getRtlOrLtr = () => {
    return isRTL() ? 'rtl' : 'ltr'
}

export const getRightOrLeft = () => {
    return isRTL() ? 'right' : 'left'
}
